{
  "en": {
    "table": {
      "cells": {
        "storageLocation": {
          "personal": "My Content"
        }
      },
      "columns": {
        "access": "Access",
        "author": "Owner",
        "created": "Created at",
        "date": "Date",
        "deletion": "Deleted at",
        "invitedBy": "Invited by",
        "joinedAt": "Joined on",
        "name": "Name",
        "projects": "Projects",
        "school": "School",
        "select": "Select",
        "selectAll": "Select all",
        "status": "Status",
        "progress": "Progress",
        "feedback": "Feedback",
        "updatedAt": "Updated at",
        "updated_at": "Updated at",
        "folder": "Folder",
        "storageLocation": "Storage Location",
        "source": "Source",
        "responses": "Responses",
        "responsesCount": "Response count",
        "drafts": "Drafts",
        "preCorrections": "Pre-corrections",
        "title": "Title",
        "archivedAt": "Archived at",
        "description": "Description",
        "projectsCount": "Projects"
      },
      "author": {
        "currentUser": "Me"
      },
      "emptyState": {
        "noContent": "No content found",
        "noSearchResults": "No results for this search."
      },
      "rowActions": "Actions"
    }
  }
}
